var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7783 0.273438H3.88943C1.90332 0.273438 0.296376 1.89844 0.296376 3.88455L0.27832 36.3845L7.50054 29.1623H32.7783C34.7644 29.1623 36.3894 27.5373 36.3894 25.5512V3.88455C36.3894 1.89844 34.7644 0.273438 32.7783 0.273438ZM20.1394 21.9401H16.5283V18.329H20.1394V21.9401ZM20.1394 14.7179H16.5283V7.49566H20.1394V14.7179Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatWarning);
export default __webpack_public_path__ + "static/media/icon_chat-warning.cf0e1cb8d4db70ad7c3490cf37deda27.svg";
export { ForwardRef as ReactComponent };